const encodeURL = url => ((url && `/b/${btoa(url)}`) || "")
export default encodeURL
